<template>
	<span>
		<em class="lt_text">Item {{ headers.class }} Range : </em>
		<em class="lt_text">From {{ headers.class }} </em>
		<span class="int_type_no_border mgr_5">
			<ItemClassSelect v-model="from_class" :showName="false" />
		</span>
		<span class="mgr_5"> ~ </span>
		<em class="lt_text">To {{ headers.class }} </em>
		<span class="int_type_no_border">
			<ItemClassSelect v-model="to_class" :showName="false" />
		</span>
		<a href="javascript: void(0);" class="gray_bt" @click="search()">{{ btnTitle }}</a>
	</span>
</template>

<script>
import ItemClassSelect from '@/components/common/ItemClassSelect.vue';
import { apiSelectItemClassByStringRange } from '@/api/item/class.js';
export default {
	data: () => ({
		from_class: null,
		to_class: null,
	}),
	components: {
		ItemClassSelect,
	},
	props: {
		btnTitle: {
			type: String,
			default: 'Range Search',
		},
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	methods: {
		async search() {
			if (!this.from_class || !this.to_class) return this.$toast.error('Please Input From/To Code.');

			let { data } = await apiSelectItemClassByStringRange(this.from_class, this.to_class);
			if (!data.length) {
				this.$toast.error(`No ${this.headers.class} Codes In the Range.`);
			} else if (data.length > 100) {
				this.$toast.error(`To Prevent System Overload<br />Limit the Number of Search Results to 100.`);
				return;
			}

			this.$emit('input', data);
		},
	},
};
</script>

<style></style>
